import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=6c424cba&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=6c424cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c424cba",
  null
  
)

export default component.exports